import React, {useState, useEffect} from "react";
import {Modal} from "antd";
import {Objections} from "../../../shiftScore/objections/Objections";
import {StyledModal} from "./CustomerObjectionsModal.styles";
import {useTranslation} from "react-i18next";

export const CustomerObjectionsModal = ({visible, onCancel}) => {
    const {t} = useTranslation();
    const [modalKey, setModalKey] = useState(0);

    useEffect(() => {
        if (visible) {
            setModalKey(prev => prev + 1);
        }
    }, [visible]);

    return (
        <StyledModal>
            <Modal
                visible={visible}
                onCancel={onCancel}
                width="85%"
                footer={null}
                title={t("screens.shiftReportObjections", {ns: "common"})}
                className="customer-objections-modal"
                style={{
                    maxHeight: "90vh",
                    top: "2vh"
                }}
                bodyStyle={{
                    maxHeight: "calc(90vh - 20px)",
                    overflowY: "auto"
                }}
            >
                <div>
                    <Objections key={modalKey} onCancel={onCancel} />
                </div>
            </Modal>
        </StyledModal>
    );
};
